import {
  DestroyRef,
  Directive,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import {
  disableFormControls,
  enableFormControls,
  getAllDisabledFormControls,
  getAllFormControls,
} from '../../utils/form-control/form-control.utils';

@Directive({
  selector: '[appFormDisabled]',
  standalone: true,
})
export class FormDisabledDirective implements OnInit {
  destroyRef = inject(DestroyRef);

  readonly appFormDisabled = input(false);
  readonly formGroup = input<UntypedFormGroup>();

  private existingDisabledControls: AbstractControl[] = [];
  private formDisabled$ = new BehaviorSubject<boolean>(false);

  constructor() {
    effect(() => {
      this.formDisabled$.next(this.appFormDisabled());
    });
  }

  ngOnInit(): void {
    if (!this.formGroup()) {
      console.error('appFormDisabled must be passed formGroup');
      return;
    }
    this.listenToDisabledStateChanges();
  }

  private listenToDisabledStateChanges(): void {
    this.formDisabled$
      .pipe(
        distinctUntilChanged(),
        filter(
          (disabled: boolean) =>
            !!this.formGroup() && disabled !== this.formGroup()!.disabled,
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((disabled: boolean) => {
        const formGroup = this.formGroup();
        const controls = getAllFormControls(formGroup);

        if (disabled) {
          this.existingDisabledControls = getAllDisabledFormControls(formGroup);
          disableFormControls(...controls);
        } else {
          enableFormControls(...controls);
          disableFormControls(...this.existingDisabledControls);
        }
      });
  }
}
